import script from "./PopoverMenuItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./PopoverMenuItem.vue?vue&type=script&lang=ts&setup=true"

import "./PopoverMenuItem.vue?vue&type=style&index=0&id=2f137c4f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f137c4f"]])

export default __exports__